import React, { Component } from 'react';
import "./Plate.scss";

export default class Plate extends Component {
  render() {
    let classNames = [
      "plate",
      this.props.theme ? this.props.theme : "",
      this.props.className
    ];

    return (
      <div className={classNames.join(" ").trim()}>
        <div className={classNames[0] + "__label"}>
          { this.props.label }
        </div>
        <div className={classNames[0] + "__value"}>
          { this.props.value }
        </div>
        <div className={classNames[0] + "__type"}>
          { this.props.type }
        </div>
      </div>
    )
  }
}
